import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxB2BAddToCartUnitSettingsScheme = z.object({
  b2b_add_to_cart_unit_dropdown_style:
    themeScheme.DropdownIdScheme.default("dropdown$$1").catch("dropdown$$1"),
});
